var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 21,
    rx: 2.5,
    stroke: "#9C4F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.136 12.208V11.024H15.76V12.208H11.136Z",
    fill: "#9C4F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIconSmall);
export default __webpack_public_path__ + "static/media/minus-icon-small.edb5959313b18eb4a8229bc508cb231c.svg";
export { ForwardRef as ReactComponent };